
import Vue from 'vue'
import iconDescription from '@/assets/icons/description.svg'
import iconPajaksafe from '@/assets/icons/pajaksafe.svg'

export default Vue.extend({
	name: 'AccessInfoSection',
	props: {
		companyName: {
			type: String,
			required: true
		},
		companyNpwp: {
			type: String,
			required: true
		},
		requesterName: {
			type: String,
			required: true
		},
		serviceName: {
			type: String,
			required: true
		},
		serviceLearnMoreUrl: {
			type: String,
			required: true
		}
	},
	data() {
		return {
			iconDescription,
			iconPajaksafe
		}
	}
})
